import React from 'react';

class SeosonalSwapReschedule extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      StoreMyself: false,
      StoreSorat: false,
      bookSorat: false,
      loading: false,
      firstName: '',
      lastName: '',
      email: '',
      Date: '',
      text: '',
      selectedDate: null,
      selectedTime: null,
      booksubmited: false,
      reservationCode: '',
      selectedYear: null,
      selectedMonth: null,
      selectedDay: null,
      serverDate: null,
      serverDateString: null,
      bookedTimes: [],
      blockedDates: [],
      fullyBookedDates: [],
      formData: {
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        carType: '',
      },
      imageUrl: '',
      offsetDays: 1,
      duplicateDialogOpen: false,
      duplicateInfo: null,
      allBookings: [] // Store all bookings with email info
    };
  }

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    
    this.setState({
      oldReservationCode: urlParams.get('code') || '',
      text: urlParams.get('note') || '',
      firstName: urlParams.get('name') || '',
      lastName: urlParams.get('family') || '',
      phone: urlParams.get('phone') || '',
      email: urlParams.get('email') || '',
      carType: urlParams.get('car') || '',
      bookSorat: true
    }, this.fetchBookingSettings);

    console.log('Parsed Params:', {
      code: urlParams.get('code'),
      note: urlParams.get('note'),
      name: urlParams.get('name'),
      family: urlParams.get('family'),
      phone: urlParams.get('phone'),
      email: urlParams.get('email'),
      car: urlParams.get('car')
    });

    fetch('https://panel.sorat.ca/apii/get_server_time.php')
    .then(response => response.json())
    .then(data => {
      if (data.success && data.server_time) {
        // The server returns Vancouver's current date/time (already DST-corrected).
        // Keep the date part as the authoritative Vancouver "today" so the calendar
        // never drifts due to the customer's local timezone or DST transitions.
        const serverDate = new Date(data.server_time);
        const serverDateString = data.server_time.slice(0, 10); // YYYY-MM-DD
        this.setState({ serverDate, serverDateString });
      }
    })
    .catch(err => {
      console.error("Failed to load server date", err);
      // Fallback is handled in getVancouverTodayRaw() using the Vancouver timezone.
      this.setState({ serverDate: null, serverDateString: null });
    });

  fetch('https://panel.sorat.ca/apii/get_blocked_dates.php')
    .then(res => res.json())
    .then(data => {
      if (data.success) {
        this.setState({ blockedDates: data.blocked_dates });
      }
    })
    .catch(err => console.error("Failed to load blocked dates", err));

  this.fetchBookedTimes();

  this.setState({bookSorat: true});
  }

  fetchBookingSettings = () => {
    // Decode HTML entities before sending
    const decodedText = this.state.text
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"');

    fetch('https://panel.sorat.ca/apii/get_booking_settings.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ text: decodedText })
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        this.setState({
          offsetDays: data.offsetDays || 0,
          slotDuration: data.slotDuration || 30,
          fullyBookedDates: Array.isArray(data.fullyBookedDates) ? data.fullyBookedDates : [],
          loading: false
        });
      } else {
        console.error('Booking settings not found');
        this.setState({ loading: false });
      }
    })
    .catch(error => {
      console.error('Error fetching booking settings:', error);
      this.setState({ loading: false });
    });
  }
  
  startSeasonalShopping = (category) => {

    if (category === 'My Wheels/Tires are stored with Sorat Wheels') {
      if (!window.localStorage.getItem("storage") || window.localStorage.getItem("storage")) {
        window.localStorage.setItem("storage", " ");
      }
      this.setState({ 
        text: 'My Wheels and/or Tires are stored with Sorat Wheels',
        bookSorat: true,
        loading: true
      }, this.fetchBookingSettings); // fetch settings after setState
    } else {
      this.setState({ 
        StoreMyself: true
      });
    }
  }

   renderSeasonalCategory = (imageUrl, category, disabled) => {
    return (

     <div className="categories-block__column_hooman categories-block__column">
       <div className="categories-block__column__imageContainer">
         <img src={window.host + imageUrl} style={{ width: '100%', height: '100%' }}className="categories-block__image" />
       </div>
       <div className="categories-block__btn-container_afterstorage" />
       <div className="categories-block__btn-container">
         <button disabled={disabled}
           className="categories-block__btnstorage" style={{font: '-webkit-control'}}
           onClick={() => this.startSeasonalShopping(category)} >
           {category}
         </button>
       </div>
     </div>
    );
  }

  renderSeasonalCategoryPanels = () => {
    return (
      <div className="categories-block__categories-box" style={{ width: '100%' }}>
       <div id="categoryImageAndButtons" className="categories-block__row">
         { this. renderSeasonalCategory('/statics/img/winterstore.jpg', 'My Wheels/Tires are stored with Sorat Wheels', false) }
         { this. renderSeasonalCategory('/statics/img/swap02.jpg', 'I have my Wheels/Tires and will bring with me to the appointment', false) }
       </div>
     </div>
    );
  }

  getVancouverTodayRaw() {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'America/Vancouver',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).formatToParts(new Date());
    const map = {};
    parts.forEach(part => { map[part.type] = part.value; });
    return `${map.year}-${map.month}-${map.day}`;
  }

  getDatesFromToday(offsetDays, numDays) {
    const dates = [];
    const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    // "Today" in Vancouver: prefer the server-reported date (authoritative and already
    // DST-corrected on the API), otherwise derive it from the Vancouver timezone.
    const todayRaw = this.state.serverDateString || this.getVancouverTodayRaw();
    const [baseYear, baseMonth, baseDay] = todayRaw.split('-').map(Number);

    // Anchor at UTC noon so adding whole days never crosses a Vancouver date boundary.
    const base = new Date(Date.UTC(baseYear, baseMonth - 1, baseDay, 12, 0, 0));

    for (let i = offsetDays; i < offsetDays + numDays; i++) {
      const date = new Date(base.getTime() + i * 24 * 60 * 60 * 1000);
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, '0');
      const day = String(date.getUTCDate()).padStart(2, '0');

      dates.push({
        weekday: weekdays[date.getUTCDay()],
        dayMonth: `${months[date.getUTCMonth()]} ${date.getUTCDate()}`,
        year: year,
        raw: `${year}-${month}-${day}`,
        isSunday: date.getUTCDay() === 0,
      });
    }

    return dates;
  }

  handleDateClick(date, year, dayMonth, weekday) {
    // Refresh booking data to ensure up-to-date availability before showing time slots
    this.refreshBookingData(date).then(() => {
      this.setState({ selectedDate: date, selectedYear: year, selectedMonth: dayMonth, selectedDay: weekday});
      console.log('selectedDate:', date);
    });
  }

  handleTimeClick(time) {
    this.setState({ selectedTime: time });
  }

  handleFormChange = (e) => {
    const { name, value } = e.target;
    const formData = Object.assign({}, this.state.formData);
    formData[name] = value;
    this.setState({ formData });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form Submitted:', this.state.formData);
      this.submitBooking();
  }

  submitBooking = () => {
    // Set submitting state
    this.setState({ isSubmitting: true });
    
    const calculateEndTime = (startTime, durationMinutes) => {
      const [hours, minutes] = startTime.split(':').map(Number);
      
      let totalMinutes = hours * 60 + minutes + durationMinutes;
      const newHours = Math.floor(totalMinutes / 60);
      const newMinutes = totalMinutes % 60;
      
      return `${newHours}:${newMinutes === 0 ? '00' : newMinutes}`;
    };

    const endTime = calculateEndTime(this.state.selectedTime, this.state.slotDuration || 30);
    
    const templateParams = Object.assign({}, this.state.formData, {
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      phone: this.state.phone,
      email: this.state.email,
      carType: this.state.carType,
      datetime: `${this.state.selectedTime}`,
      dateday: `${this.state.selectedDate}`,
      endtime: endTime ? endTime : '',
      note: `${this.state.text}`,
      color: this.state.text.includes('Sorat') || this.state.text.includes('bolted on') ? '#255706' : this.state.text.includes('Loose') ? 'blue' : 'red',    });

    // Step 1: Submit the new booking first
    fetch('https://soratwheels.ca/apii/submitcalender.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(templateParams),
    })
    .then(response => response.json())
    .then(data => {
      console.log("API Response:", data); 
      this.setState({ isSubmitting: false });

      if (data.success) {
        // Step 2: Update state and send email
        this.setState({ 
          booksubmited: true, 
          reservationCode: data.reservationCode,
        }, () => {
          console.log("Updated State:", this.state.booksubmited, this.state.reservationCode);

          // Choose email endpoint based on note content
          const emailEndpoint = this.state.text.includes('My Wheels and/or Tires are stored with Sorat Wheels') 
            ? 'https://panel.sorat.ca/apii/sendemailstorage.php'
            : 'https://panel.sorat.ca/apii/sendemail.php';
          
          // Send email
          fetch(emailEndpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              email: this.state.email,
              firstName: this.state.firstName,
              lastName: this.state.lastName,
              reservationCode: data.reservationCode,
              date: data.date,
              time: this.state.selectedTime,
              note: this.state.text,
              car: this.state.carType,
              phone: this.state.phone,
            }),
          });
          
          // Step 3: Cancel the old reservation
          const oldReservationCode = this.state.oldReservationCode;
          if (oldReservationCode) {
            fetch("https://panel.sorat.ca/apii/cancel_reservation.php", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ reservationCode: oldReservationCode })
            })
            .then(response => response.json())
            .then(data => {
              console.log("Cancellation response:", data);
            })
            .catch(error => {
              console.error("Cancel Error:", error);
            });
          }
        });
      } else {
        alert("Failed to book appointment: " + data.message);
      }
    })
    .catch(error => {
      console.error('Error:', error);
      this.setState({ isSubmitting: false });
    });
  }

  getMaxBookingsForSlot = (slot) => {
    return (slot === '13:00' || slot === '13:30') ? 2 : 3;
  }

  renderTimeSlots() {
    const slots = [];
    const selectedDay = this.state.selectedDate ? this.state.selectedDate : null;
    const bookedForSelectedDay = selectedDay ? this.state.bookedTimes[selectedDay] || [] : [];

    // Get current Vancouver time
    const vancouverTime = new Date().toLocaleString("en-US", { timeZone: "America/Vancouver" });
    const currentVancouverDate = new Date(vancouverTime);
    const currentVancouverHour = currentVancouverDate.getHours();
    const currentVancouverMinute = currentVancouverDate.getMinutes();
    
    // Get today's date in Vancouver timezone
    const todayDateString = currentVancouverDate.toISOString().split('T')[0];
    const isToday = selectedDay === todayDateString;

    // Count bookings for each time slot
    const bookingCounts = {};
    bookedForSelectedDay.forEach(slot => {
      bookingCounts[slot] = (bookingCounts[slot] || 0) + 1;
    });

    const stepMinutes = this.state.slotDuration || 30; 
    const startHour = this.state.selectedDay === 'Saturday' ? 10 : 9;
    const endHour = this.state.selectedDay === 'Saturday' ? 14 : 16;

    for (let hour = startHour; hour <= endHour; hour++) {
      for (let minute = 0; minute < 60; minute += stepMinutes) {
        const formattedHour = hour.toString().padStart(2, '0');
        const formattedMinute = minute === 0 ? '00' : minute.toString().padStart(2, '0');
        const slot = `${formattedHour}:${formattedMinute}`;

        const count = bookingCounts[slot] || 0;
        const maxBookings = this.getMaxBookingsForSlot(slot);
        const isBooked = count >= maxBookings;
        
        // Check if slot is in the past (ONLY for today, with 2 hour buffer)
        let isPastTime = false;
        if (isToday) {
          const slotTotalMinutes = hour * 60 + minute;
          const currentTotalMinutes = currentVancouverHour * 60 + currentVancouverMinute + 120; // 2 hour buffer
          isPastTime = slotTotalMinutes < currentTotalMinutes;
        }

        const isDisabled = isBooked || isPastTime;

        slots.push(
          <button
            className="vehicleSelection-contentTires__btnlist"
            key={slot}
            style={{
              margin: '5px',
              padding: '8px',
              cursor: isDisabled ? 'not-allowed' : 'pointer',
              opacity: isDisabled ? 0.5 : 1
            }}
            disabled={isDisabled}
            onClick={() => !isDisabled && this.handleTimeClick(slot)}
            title={isPastTime ? 'This time has passed' : (isBooked ? 'Fully booked' : '')}
          >
            {slot}
          </button>
        );
      }
    }
    return slots;
  }
  
  fetchBookedTimes() {
    fetch('https://soratwheels.ca/apii/booklist.php')
      .then(response => response.json())
      .then(data => {
        if (data.success && data.booked) {
          const bookedMap = {};
          // Store all bookings with complete info
          this.setState({ allBookings: data.booked });
          
          data.booked.forEach(item => {
            if (!bookedMap[item.dateday]) {
              bookedMap[item.dateday] = [];
            }
            bookedMap[item.dateday].push(item.datetime);
          });
          this.setState({ bookedTimes: bookedMap });
        }
      })
      .catch(error => console.error('Error fetching booked times:', error));
  }

  refreshBookingData(date) {
    return new Promise((resolve, reject) => {
      const timestamp = new Date().getTime();
      fetch(`https://soratwheels.ca/apii/booklist.php?nocache=${timestamp}`)
        .then(response => response.json())
        .then(data => {
          if (data.success && data.booked) {
            const bookedMap = {};
            this.setState({ allBookings: data.booked });

            data.booked.forEach(item => {
              if (!bookedMap[item.dateday]) {
                bookedMap[item.dateday] = [];
              }
              bookedMap[item.dateday].push(item.datetime);
            });

            this.setState({ bookedTimes: bookedMap }, () => {
              resolve();
            });
          } else {
            resolve();
          }
        })
        .catch(error => {
          console.error('Error fetching booked times:', error);
          reject(error);
        });
    });
  }

  renderForm() {
    const { firstName, lastName, phone, email, carType } = this.state.formData;
    return (
      <form onSubmit={this.handleSubmit} style={{ marginTop: '20px', maxWidth: '600px', margin: '20px auto', padding: '10px' }}>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
          <input type="text" name="firstName" value={this.state.firstName} onChange={this.handleFormChange} required style={{ flex: '1', minWidth: '200px', padding: '8px' }} disabled/>
          <input type="text" name="lastName" value={this.state.lastName} onChange={this.handleFormChange} required style={{ width: '100%', flex: '1', padding: '8px' }} disabled/>
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginTop: '10px' }}>
          <input type="tel" name="phone"  value={this.state.phone} onChange={this.handleFormChange} required style={{ width: '100%', flex: '1', padding: '8px' }} disabled/>
          <input type="email" name="email" value={this.state.email} onChange={this.handleFormChange} required style={{ width: '100%', flex: '1', padding: '8px' }} disabled/>
        </div>
        <input type="text" name="carType" value={this.state.carType} onChange={this.handleFormChange} required style={{ width: '100%', padding: '8px', margin: '10px 0' }} disabled/>
        <input type="text" name="note" value={this.state.text} hidden style={{ width: '100%', padding: '8px', margin: '10px 0' }} />

        <button type="submit" style={{ width: '100%', padding: '10px', marginTop: '10px', backgroundColor: '#c50000', color: '#fff', border: 'none', borderRadius: '5px' }}>Submit</button>
      </form>
    );
  }

  handleBack = () => {
    this.setState({ selectedDate: null, selectedTime: null, StoreSorat: false });
  };

  handleNext = () => {
    this.setState((prevState) => {
      const newOffset = prevState.offsetDays + 12;
      return newOffset <= 60 ? { offsetDays: newOffset } : prevState;
    });
  };

  handlePrev = () => {
    this.setState((prevState) => {
      const newOffset = prevState.offsetDays - 12;
      return newOffset >= 0 ? { offsetDays: newOffset } : { offsetDays: this.state.offsetDays };
    });
  };

  render() {   
    if (this.state.loading) {
      return (
                    <div>
                        {navigator.userAgent.toLowerCase().indexOf('chrome') > -1 || navigator.userAgent.toLowerCase().indexOf('firefox') > -1 ?
                            <img src={'https://www.soratwheels.ca/media/loading/loading.svg'}/> :
                            <img src={'https://www.soratwheels.ca/media/loading/loading.gif'}/>}
                    </div>
      );
    } 
    
    else if ( this.state.bookSorat && !this.state.selectedDate) {

      const todayRaw = this.state.serverDateString || this.getVancouverTodayRaw();
      const [todayYear, todayMonthNum, todayDayNum] = todayRaw.split('-').map(Number);
      const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      const todayFormatted = `${weekdays[new Date(Date.UTC(todayYear, todayMonthNum - 1, todayDayNum)).getUTCDay()]}, ${months[todayMonthNum - 1]} ${todayDayNum}, ${todayYear}`;
      
      const futureDates = this.getDatesFromToday(this.state.offsetDays, 12);
      const rows = [];
      for (let i = 0; i < futureDates.length; i += 4) {
        rows.push(futureDates.slice(i, i + 4));
      }

      return (
        <div style={{ height: 'auto', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
         <div className="content-divLength" style={{minHeight: '550px', paddingTop: '2px !important'}}>
          <div id="sizesContainer_WheelsVehicle" className="size-selectingStaggeredOrNot custom_container calendercss" style={{padding: '20px 10px 20px 10px'}}>

          <h2 style={{color: 'white', marginBottom: '5px'}}>Reschedule Your Appointment</h2>
          <h4 style={{color: 'white', marginBottom: '5px'}}>Today: {todayFormatted}</h4>
          <h4 style={{color: 'white', marginBottom: '15px'}}>Hi {this.state.firstName}, Please Select a New Date</h4>

  {rows.map((row, rowIndex) => (
    <div key={rowIndex} style={{ display: 'flex', flexDirection: 'row', marginBottom: '10px', justifyContent: 'center' }}>
      {row.map(date => {
      
  const isSunday = date.isSunday;
  const isBlockedHoliday = this.state.blockedDates.includes(date.raw);
  const isFullyBookedDate = this.state.fullyBookedDates.includes(date.raw);
  const isSaturday = date.weekday === 'Saturday' && this.state.text === 'I have Loose tires that need to be mounted & balanced';

  const bookedTimesForDay = this.state.bookedTimes[date.raw] || [];

  let availableTimes = [];
  const startHour = (date.weekday === 'Saturday') ? 10 : 9;
  const endHour = (date.weekday === 'Saturday') ? 14 : 16;
  const slotDuration = this.state.slotDuration || 30;

for (let hour = startHour; hour <= endHour; hour++) {
  const formattedHour = hour.toString().padStart(2, '0');
  if (slotDuration === 30) {
    availableTimes.push(`${formattedHour}:00`);
    availableTimes.push(`${formattedHour}:30`);
  } else {
    availableTimes.push(`${formattedHour}:00`);
  }
}

if (slotDuration === 30 && !availableTimes.includes(`${endHour}:30`)) {
  availableTimes = availableTimes.filter(time => !time.endsWith(":30"));
}

const bookingCounts = {};
bookedTimesForDay.forEach(time => {
  bookingCounts[time] = (bookingCounts[time] || 0) + 1;
});

const isFullyBooked = availableTimes.every(time => {
  const count = bookingCounts[time] || 0;
  return count >= this.getMaxBookingsForSlot(time);
});

const isDisabled = isSunday || isBlockedHoliday || isFullyBookedDate || isSaturday || isFullyBooked;

      return (
        <button
          className="vehicleSelection-contentTires__btnlist"
          key={date.raw}
          onClick={() => !isDisabled && this.handleDateClick(date.raw, date.year, date.dayMonth, date.weekday)}
          style={{
            margin: '5px',
            padding: '8px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            boxShadow: 'inset 3px 3px 6px 1px #770404',
            height: 'auto',
            cursor: isDisabled ? 'not-allowed' : 'pointer',
            opacity: isDisabled ? 0.5 : 1
          }}
          disabled={isDisabled}
          title={
            isSunday ? 'Closed on Sunday'
            : isBlockedHoliday ? 'Not available'
            : isSaturday ? 'Loose tires not allowed on Saturday'
            : (isFullyBookedDate || isFullyBooked) ? 'Fully booked for this day'
            : ''
          }
        >
          <span style={{backgroundColor: '#2d2b2b', width: 'inherit'}}>{date.weekday}</span>
          <span style={{textShadow: '1px -1px 2px black'}}>{date.dayMonth}</span>
          <span>{date.year}</span>
        </button>
      );
    })}
  </div>
))}
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
                <button onClick={this.handlePrev} style={{ padding: '10px 20px', backgroundColor: '#444', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', width: '20%' }}>Prev</button>
                <button onClick={this.handleNext} style={{ padding: '10px 20px', backgroundColor: '#444', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', width: '20%' }}>Next</button>
              </div>

        </div>
             </div> 
                 </div>
      );

    } else if (this.state.selectedDate && !this.state.selectedTime) {
      return (
        <div style={{ height: 'auto', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
         <div className="content-divLength" style={{minHeight: '550px', paddingTop: '2px !important'}}>
          <div id="sizesContainer_WheelsVehicle" className="size-selectingStaggeredOrNot custom_container" style={{padding: '20px 10px 20px 10px'}}>
          
            <h4 style={{color: 'white', marginBottom: '15px'}}> Your New Date: <strong style={{backgroundColor: '#c50000', padding: '10px'}}>{this.state.selectedDay}, {this.state.selectedMonth}, {this.state.selectedYear}</strong></h4>
            <h4 style={{color: 'white', marginBottom: '5px'}}>Please Select a New Time</h4>
            <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
              {this.renderTimeSlots()}
            </div>
            <button onClick={this.handleBack} style={{ padding: '20px 20px', backgroundColor: '#00000042', color: '#e9b1b1', border: 'none', textDecoration: 'underline', cursor: 'pointer' }}>
                  Back to Select Date
            </button>
        </div>
      </div>
    </div>
      );
    } else if (this.state.selectedTime && this.state.selectedDate && !this.state.booksubmited) {
      return (
        <div style={{ height: 'auto', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
         <div className="content-divLength" style={{minHeight: '550px', paddingTop: '2px !important'}}>
           <div id="sizesContainer_WheelsVehicle" className="size-selectingStaggeredOrNot custom_container" style={{padding: '20px 10px 20px 10px'}}>
              <h4 style={{color: 'white', marginBottom: '15px'}}> Your Date: <strong style={{backgroundColor: '#c50000', padding: '10px'}}>{this.state.selectedDay}, {this.state.selectedMonth}, {this.state.selectedYear}</strong></h4>
              <h4 style={{color: 'white', marginBottom: '15px'}}> Time: <strong style={{backgroundColor: '#c50000', padding: '10px'}}>{this.state.selectedTime}</strong></h4>
              {this.renderForm()} 
              <span style={{color: 'white', marginBottom: '5px'}}> *Automate previous appointment will be canceled & a new one will be created.</span>
           </div>
        </div>
      </div>
      );
    } else if (this.state.booksubmited && this.state.selectedTime && this.state.selectedDate && this.state.reservationCode) {

      return (
        <div style={{ height: 'auto', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}> 
         <div className="content-divLength" style={{minHeight: '550px', paddingTop: '2px !important'}}>
          <div id="sizesContainer_WheelsVehicle" className="size-selectingStaggeredOrNot custom_container" style={{padding: '20px 10px 20px 10px'}}>
        <h4 style={{ color: 'white', marginBottom: '15px' }}>Service Date: <strong style={{ backgroundColor: '#c50000', padding: '10px' }}>{this.state.selectedDay}, {this.state.selectedMonth}, {this.state.selectedYear}</strong></h4>
        <h4 style={{ color: 'white', marginBottom: '15px' }}>Service Time: <strong style={{ backgroundColor: '#c50000', padding: '10px' }}>{this.state.selectedTime}</strong></h4>
        <h4 style={{ color: 'white', marginBottom: '15px' }}>Reservation Code: <strong style={{ backgroundColor: '#c50000', padding: '10px' }}>{this.state.reservationCode}</strong></h4>
        <h4 style={{ color: 'white', marginBottom: '15px' }}><strong style={{ backgroundColor: 'Black', padding: '10px' }}>Your booking is confirmed</strong></h4>
        </div>
       </div>
      </div>
      );
    }

    return (
         <div className="breadcrumbbar__categoriesContainer">
           {this.renderSeasonalCategoryPanels()}   
       </div>
    );
  }
}

export default SeosonalSwapReschedule;



// WEBPACK FOOTER //
// ./src/components/SeasonalSwapReschedule.js